var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUralhim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uralhim_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 789.49 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uralhim_svg__cls-1{fill:#509a6a}.uralhim_svg__cls-2{fill:#4b5d95}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uralhim_svg__cls-1",
    d: "M470.52 196v54.65c-.51 7.73-2.75 15.3-12.77 15.3V286c34 0 35.11-13 35.11-35.35V216h41.52v70h23.13v-90zM343.76 224.72c0-28.34-25.25-28.36-46.25-28.72h-48.28v90h23.14v-32.56h25.14c21-.36 46.25-.38 46.25-28.72m-47.09 11.44h-24.3v-22.88h24.3c16.89 0 23.79 0 23.79 11.44s-6.9 11.44-23.79 11.44",
    transform: "translate(-133.92 -196)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uralhim_svg__cls-1",
    d: "M54.59 42.36L29.06 0H0l41.03 65.33L27.02 90h27.72l52.39-90H79.4L54.59 42.36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uralhim_svg__cls-1",
    d: "M376.82 196l-41.29 90h25.11l7.62-17.28H416l7.89 17.28h26.67l-43-90zm-.93 55.45l15.73-35.64L408 251.45z",
    transform: "translate(-133.92 -196)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uralhim_svg__cls-2",
    d: "M775.93 0h-23.1l-27.7 71.64L697.42 0h-36.69v90h23.13V24.84L710.2 90h29.36l26.79-66.29V90h23.14V0h-13.56zM571.38 62.25V0h-23.13v90h25.46l47.86-61.3V90h23.13V0h-25.79l-47.53 62.25zM510.55 0l-23.56 27.74L464.21 0H434.1l37.78 45.52L434.1 90h25.96l24.61-28.38L507.97 90h30.12l-38.16-45.99L538.09 0h-27.54z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUralhim);
export default __webpack_public_path__ + "static/media/uralhim.3d5be08f4da9fbd757737abf52e094ee.svg";
export { ForwardRef as ReactComponent };